<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 199">
    <title>battery-17-17</title>
    <g id="Battery">
      <path
        class="cls-1"
        d="M178.26,149.52l-155,0,0-92,155,0ZM73.51,43.49h-31v14h31Zm85,0h-31v14h31Zm27.48,106-170.5,0v6l170.5,0Zm-31.49-64h-24m-61,0h-24m97,12v-24m-98-23h29m55.5,0h29"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "BatteryIcon",
};
</script>

<style scoped>
.cls-1 {
  fill: transparent;
  stroke: currentColor;
  stroke-linejoin: round;
  stroke-width: 10px;
}
</style>
